import script from "./MitiServicesView.vue?vue&type=script&setup=true&lang=js"
export * from "./MitiServicesView.vue?vue&type=script&setup=true&lang=js"

import "./MitiServicesView.vue?vue&type=style&index=0&id=3151b6ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3151b6ab"]])

export default __exports__